import { Box, makeStyles } from "@material-ui/core";
import clsx from "clsx";
import { Form, Formik } from "formik";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useFirebase, useFirestore } from "react-redux-firebase";
import { Link, Redirect } from "react-router-dom";
import { AuthTypeAction, ReduxAction, RootState } from "redux/model";
import {
    InputFieldFormik,
    SubmitButton,
    Subtitle,
    Title,
} from "ui/componentes";
import { Message } from "ui/componentes/Message";

const useStyles = makeStyles((theme) => ({
    marginTop: {
        marginTop: theme.spacing(2),
    },
    marginLeft: {
        marginLeft: theme.spacing(1),
    },
}));

const initialValues = {
    firstName: "",
    lastName: "",
    email: "",
    password: "",
};

const SignUp = () => {
    const classes = useStyles();
    const { auth } = useSelector((state: RootState) => state.firebase);
    const { authError } = useSelector(
        (state: RootState) => state.authAppReducer
    );
    const dispatch = useDispatch();
    const firebase = useFirebase();
    const firestore = useFirestore();

    useEffect(() => {
        dispatch<ReduxAction>({
            type: AuthTypeAction.CLEAN_AUTH_ERROR,
            data: {},
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (auth.uid) {
        return <Redirect to="/" />;
    }

    return (
        <Formik
            initialValues={initialValues}
            onSubmit={(values, helpers) =>
                firebase
                    .auth()
                    .createUserWithEmailAndPassword(
                        values.email,
                        values.password
                    )
                    .then(({ user }) => {
                        if (user) {
                            // user.sendEmailVerification();
                            return firestore
                                .collection("users")
                                .doc(user.uid)
                                .set({
                                    firstName: values.firstName,
                                    lastName: values.lastName,
                                    initials:
                                        values.firstName[0] +
                                        values.lastName[0],
                                });
                        }
                    })
                    .then(() => {
                        dispatch({ type: "SIGN_UP_SUCCESS" });
                        helpers.setSubmitting(false);
                    })
                    .catch((error) => {
                        dispatch({ type: "SIGN_UP_ERROR", data: error });
                        helpers.setSubmitting(false);
                    })
            }
        >
            {() => (
                <Form>
                    <Box
                        id="signIn"
                        width="100%"
                        height="100vh"
                        display="flex"
                        flexDirection="column"
                        alignItems="center"
                        justifyContent="center"
                        bgcolor="#F5F5F5"
                    >
                        <Box maxWidth={600}>
                            <Message
                                message={authError}
                                variant="error"
                                show={!!authError}
                            />
                            <Title
                                text="Create a new account"
                                className={classes.marginTop}
                            />
                            <InputFieldFormik
                                required
                                id="firstName"
                                name="firstName"
                                label="First name"
                                margin="normal"
                                className={classes.marginTop}
                            />
                            <InputFieldFormik
                                required
                                id="lastName"
                                name="lastName"
                                label="Last name"
                                margin="normal"
                                className={classes.marginTop}
                            />
                            <InputFieldFormik
                                required
                                id="email"
                                name="email"
                                label="Email address"
                                margin="normal"
                                className={classes.marginTop}
                            />
                            <InputFieldFormik
                                required
                                id="password"
                                name="password"
                                label="Password"
                                type="password"
                                margin="normal"
                                className={classes.marginTop}
                            />
                            <SubmitButton
                                className={classes.marginTop}
                                size="large"
                                fullWidth
                            >
                                Sign up
                            </SubmitButton>
                            <Box display="flex">
                                <Subtitle
                                    text="Have an account?"
                                    className={classes.marginTop}
                                />
                                <Link to="sign-in">
                                    <Subtitle
                                        text="Sign in"
                                        className={clsx(
                                            classes.marginTop,
                                            classes.marginLeft
                                        )}
                                        color="primary"
                                    />
                                </Link>
                            </Box>
                        </Box>
                    </Box>
                </Form>
            )}
        </Formik>
    );
};

export { SignUp };
